import React from 'react';

const NoMatch = (props) => {
    return <div>Sorry, the page you requested does not exist.</div>;
};

export default NoMatch;
